import ComplexProductCard from '@tvg/fuse-design/complex-product-card';
import useConfigContext from 'client/context/config';
import createRecsWindowObj from 'client/utils/createRecsWindowObj';
import isApp from 'client/utils/isApp';
import {
  getContainerProviderProps,
  getProductProviderProps,
} from 'client/utils/providerProps';
import { clearText } from 'client/utils/textModifications';
import React, { useEffect, useMemo } from 'react';
import { CIORecProduct } from 'server/services/recommendation';
import { RecProvider } from 'shared/consts/recommendations';

interface AddToBasketProps extends React.HTMLAttributes<HTMLDivElement> {
  product: CIORecProduct;
  title: string;
}

interface AddToBasketProps extends React.HTMLAttributes<HTMLDivElement> {
  product: CIORecProduct;
  title: string;
}

function AddToBasket({ product, title, ...props }: AddToBasketProps) {
  const provider = RecProvider.Constructor;
  const { rec } = useConfigContext();
  const titleMemo = useMemo(
    () => clearText(product?.title ?? ''),
    [product?.title],
  );

  const brandMemo = useMemo(
    () => clearText(product?.brand ?? ''),
    [product?.brand],
  );

  const imageMemo = useMemo(
    () => ({
      url: product?.image?.url,
      altText: clearText(`Image of ${product?.brand ?? ''} ${product?.title}`),
    }),
    [product?.image?.url, product?.brand, product?.title],
  );

  useEffect(() => {
    (async () => {
      if (await isApp()) {
        createRecsWindowObj([product]);
      }
    })();
  }, [product]);

  return (
    <div {...getContainerProviderProps({ provider, rec })}>
      <h2>{title}</h2>
      <ComplexProductCard
        brand={brandMemo}
        title={titleMemo}
        image={imageMemo}
        productUrl={product.url}
        isSkeleton={false}
        price={{
          current: product.price.current,
          previous: product.price.previous,
          showSave: false,
          isEuro: product.price?.currencyCode === 'EUR',
        }}
        {...props}
        {...getProductProviderProps({ provider, product }, props)}
      />
    </div>
  );
}

export default AddToBasket;
